import { specifyAnotherField } from '_constants/onboardingConstants';
import { TranslateValueType } from '_types';

export const SELECT_ALL_FUNCTIONAL = 'select_all';
export const NONE_FUNCTIONAL = 'none';

export function getFunctionalValue(
  list: TranslateValueType[],
  functionalItem: string,
): string | undefined {
  return list.find((item) => item.functionalItem === functionalItem)?.value;
}

export function getAllSelectableValues(list: TranslateValueType[]) {
  return list
    .filter(
      (item) =>
        item.functionalItem !== SELECT_ALL_FUNCTIONAL &&
        item.functionalItem !== NONE_FUNCTIONAL &&
        item.value !== specifyAnotherField,
    )
    .map((item) => item.value);
}

export function isSelectAllChecked(
  selected: string[],
  list: TranslateValueType[],
) {
  const all = getAllSelectableValues(list);
  return all.length > 0 && all.every((v) => selected.includes(v));
}

export function getValuesForSubmission(
  selected: string[],
  list: TranslateValueType[],
) {
  const selectAllValue = getFunctionalValue(list, SELECT_ALL_FUNCTIONAL);
  const noneValue = getFunctionalValue(list, NONE_FUNCTIONAL);

  if (noneValue && selected.length === 1 && selected[0] === noneValue) {
    return [];
  }
  return selected.filter((v) => v !== selectAllValue && v !== noneValue);
}

export function getSpecifyAnotherFieldValue(
  elem: TranslateValueType,
  value: any,
  availableValuesList: TranslateValueType[],
  specifyValue: string,
) {
  if (elem.value === specifyAnotherField) {
    return value &&
      availableValuesList.findIndex((e) => e.value === value) === -1
      ? specifyValue
      : '';
  }
  return elem.name;
}

export function getFormListHeight(availableValuesList: TranslateValueType[]) {
  const maxColumnRowLength = Math.ceil(availableValuesList.length / 2);
  return maxColumnRowLength * 60 + maxColumnRowLength * 8;
}

export function isItemSelected(
  elem: TranslateValueType,
  value: string[],
  availableValuesList: TranslateValueType[],
  noneValue: string | undefined,
) {
  if (elem.functionalItem === SELECT_ALL_FUNCTIONAL) {
    return isSelectAllChecked(value, availableValuesList);
  }
  if (elem.functionalItem === NONE_FUNCTIONAL) {
    return !!(noneValue && value.length === 1 && value[0] === noneValue);
  }
  return value.includes(elem.value);
}
